/* i18n-ignore: interne adminpagina, alleen NL */
import { createFileRoute, Link } from "@tanstack/react-router";
import { ArrowLeft } from "lucide-react";
import { AdminNav } from "@/components/admin/AdminNav";
import { MediaSettingsPanel } from "@/components/admin/MediaSettingsPanel";
import { MediaTransferPanel } from "@/components/admin/MediaTransferPanel";
import { HashPanel } from "@/components/admin/media-organise/HashPanel";
import { TaxonomySettings } from "@/components/admin/media-organise/TaxonomySettings";

export const Route = createFileRoute("/_authenticated/admin/foto-instellingen")({
  staticData: { sitemap: false },
  head: () => ({
    meta: [{ title: "Foto-instellingen — Gopro Projects" }, { name: "robots", content: "noindex" }],
  }),
  component: AdminPhotoSettingsPage,
});

function AdminPhotoSettingsPage() {
  return (
    <main className="mx-auto w-full max-w-6xl px-4 py-10 sm:px-6">
      <AdminNav />
      <div className="mb-6 mt-4">
        <Link
          to="/admin/foto-ordenen"
          className="mb-2 inline-flex items-center gap-1 text-sm text-primary underline-offset-4 hover:underline"
        >
          <ArrowLeft className="h-4 w-4" aria-hidden="true" /> Foto's
        </Link>
        <h1 className="text-2xl font-extrabold tracking-tight sm:text-3xl">Foto-instellingen</h1>
        <p className="mt-1 text-sm text-muted-foreground">
          Eén keer invullen per project. Het eerste deel is voor de beheerder, het tweede keurt de klant goed.
        </p>
      </div>
      <div className="grid items-start gap-6 lg:grid-cols-2">
        <div className="space-y-6">
          <MediaSettingsPanel />
          <MediaTransferPanel />
        </div>
        <div className="space-y-6">
          <TaxonomySettings />
          <HashPanel />
        </div>
      </div>
    </main>
  );
}
